export default "__VITE_ASSET__d58a70ad__"